import { Component } from 'react';

import DayColumnWrapper, {
  DayColumnContent,
  DayDate,
  DayTitle,
  DateWrapper
} from './Wrapper';

export interface DayColumnProps {
  date: number;
  dayTitle: string;
  isActive: boolean;
}

class DayColumn extends Component<DayColumnProps> {
  render() {
    const { date, dayTitle, children } = this.props;
    return (
      <DayColumnWrapper {...this.props}>
        <DayColumnContent {...this.props}>
          <DateWrapper>
            <DayTitle>{dayTitle}</DayTitle>
            <DayDate>{date}</DayDate>
          </DateWrapper>
          {children}
        </DayColumnContent>
      </DayColumnWrapper>
    );
  }
}

export default DayColumn;
